import { render, staticRenderFns } from "./GoodsDealtownRewardForm.vue?vue&type=template&id=f5367a0a&scoped=true&"
import script from "./GoodsDealtownRewardForm.vue?vue&type=script&lang=js&"
export * from "./GoodsDealtownRewardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5367a0a",
  null
  
)

export default component.exports